import styles from './LiveProgressBar.module.scss';

const LiveProgressBar = () => {
  return <div className={styles.bar}></div>;
};

export { LiveProgressBar };
